import { FC, useMemo } from 'react'
import styles from 'components/features/future/FutureBreakDownChartSeries/FutureBreakDownChartSeries.styl'
import { PublicTrendItem } from 'interfaces/publicDashboard'
import cn from 'classnames'
import { CHART_LABELS_TILT_THRESHOLD } from 'constants/component'
import { useStoreSelector } from 'helpers/reactReduxHelpers'
import { getAgeSelector } from 'selectors/globalSelectors'
import { cssVar } from 'helpers/styleHelpers'

type FutureBreakDownChartSeriesProps = {
  items: Pick<PublicTrendItem, 'date'>[]
  index: number
  width: number
}

export const FutureBreakDownChartSeries: FC<FutureBreakDownChartSeriesProps> = (props) => {
  const { items, index, width } = props

  const getAge = useStoreSelector(getAgeSelector)

  const { shouldRotate, dimBy } = useMemo(() => {
    const sectionWidth = width / items.length

    let dimByLocal = 1
    if (sectionWidth < 10) {
      dimByLocal = 4
    } else if (sectionWidth < 25) {
      dimByLocal = 2
    }

    return {
      shouldRotate: sectionWidth < CHART_LABELS_TILT_THRESHOLD,
      dimBy: dimByLocal,
    }
  }, [width, items])

  const itemsChild = useMemo(() => {
    if (!getAge) {
      return null
    }

    return items.map((item: Pick<PublicTrendItem, 'date'>, itemIndex: number) => {
      const shouldRender = (itemIndex % dimBy) === 0
      return (
        <div
          className={ cn(styles.section, itemIndex === index && styles.highlight) }
          key={ itemIndex }
        >
          { shouldRender && (
            <div className={ styles.text }>
              { getAge(item.date) }
            </div>
          )}
        </div>
      )
    })
  }, [getAge, dimBy, index, items])

  if (!getAge) {
    return null
  }


  return (
    <div
      className={ cn(styles.futureBreakDownChartSeries, shouldRotate && styles.rotate) }
      style={ cssVar({
        '--count': items.length,
      }) }
    >
      { itemsChild }
      <div className={ styles.axisLabel }><span className={ styles.labelText }>Age</span></div>
    </div>
  )
}
